import * as xhr from "xhr";
import Utils from "platform/util/Utils";
import WebUtil from "platform/util/WebUtil";

export interface HttpHeader {
    name: string;
    value: string;
}

export enum HttpMethod {

    GET = "GET",
    POST = "POST",
    PUT = "PUT",
    UPDATE = "UPDATE",
}

export interface HttpReject {

    status?: number;
    response?: any;
}

export class Http {

    private constructor() {}

    public static async get(url: string, headers?: HttpHeader[]): Promise<any> {
        return this.execute(url, "GET", null, headers);
    }

    public static async post(url: string, data?: any, headers?: HttpHeader[]): Promise<any> {
        return this.execute(url, "POST", data, headers);
    }

    public static async getJson(url: string, headers?: HttpHeader[]): Promise<any> {
        const arr: HttpHeader[] = Utils.isArrayNotEmpty(headers) ? headers : [];
        arr.push({name: "Content-Type", value: "application/json"});
        const URL: string = WebUtil.addGetParam(url, "timestamp", new Date().getTime().toString());
        const answer: any = await Utils.to(this.execute(URL, "GET", null, arr));
        if (answer[0]) {
            return Promise.reject(answer[0]);
        } else {
            return Promise.resolve(JSON.parse(answer[1]));
        }
    }

    public static async postJson(url: string, data?: any, headers?: HttpHeader[]): Promise<any> {
        const arr: HttpHeader[] = Utils.isArrayNotEmpty(headers) ? headers : [];
        arr.push({name: "Content-Type", value: "application/json"});
        const answer: any = await Utils.to(this.execute(url, "POST", data, arr));
        if (answer[0]) {
            return Promise.reject(answer[0]);
        } else {
            return Promise.resolve(JSON.parse(answer[1]));
        }
    }

    private static async execute(url: string, method: string, data?: any, headers?: HttpHeader[]): Promise<any> {
        return new Promise<any>(
            (resolve, reject) => {
                const hs: {[key: string]: string} = {};
                if (Utils.isNotNull(headers)) {
                    headers.map((header: HttpHeader) => {
                        hs[header.name] = header.value;
                    });
                }
                (xhr as any)[method.toLowerCase()]({
                    url,
                    body: data,
                    timeout: 60000,
                    headers: hs
                }, (err, response, body) => {
                    if (response.statusCode === 200) {
                        resolve(body);
                    } else {
                        reject({status: response.statusCode, response: body});
                    }
                });
            }
        );
    }
}
